export { useFollowedCompanies } from './useFollowedCompanies';
